export { default } from "@src/Apps/Legal";
